/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';
import { Eraser } from 'lucide-react';

interface EraserControlProps {
  lineWidth: number;
  setLineWidth: (width: number) => void;
  isActive: boolean;
}

export const EraserControl: React.FC<EraserControlProps> = ({
  lineWidth,
  setLineWidth,
  isActive,
}) => {
  if (!isActive) return null;

  return (
    <div className="flex flex-col gap-3 p-3 bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800" id="eraser-selector-tool">
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-1.5 text-indigo-600 dark:text-indigo-400 border-b border-slate-100 dark:border-slate-800 pb-2">
          <Eraser className="w-4 h-4" />
          <span className="text-xs font-bold uppercase tracking-wider">Eraser Active</span>
        </div>
        
        <div className="flex items-center justify-between gap-2.5 mt-1">
          <span className="text-xs text-slate-500 dark:text-slate-400 font-bold uppercase tracking-wider">Size:</span>
          <div className="flex items-center gap-1 bg-slate-50 dark:bg-slate-950 p-1 rounded-lg border border-slate-200 dark:border-slate-800">
            {[6, 12, 24, 36].map((size) => (
              <button
                key={size}
                type="button"
                onClick={() => setLineWidth(size)}
                className={`px-2.5 py-1 rounded-md text-xs font-bold transition-all border ${
                  lineWidth === size
                    ? 'border-indigo-600 bg-indigo-50 dark:bg-indigo-950/40 text-indigo-600 dark:text-indigo-400'
                    : 'border-transparent hover:bg-slate-100 dark:hover:bg-slate-850 text-slate-500 dark:text-slate-400'
                }`}
                title={`${size}px eraser width`}
              >
                {size === 6 ? 'Fine' : size === 12 ? 'Med' : size === 24 ? 'Thick' : 'Max'}
              </button>
            ))}
          </div>
        </div>
      </div>
      <p className="text-[10px] text-slate-400 dark:text-slate-500 border-t border-slate-100 dark:border-slate-800 pt-2">
        Touch or click-drag to wipe sketches back to clean white.
      </p>
    </div>
  );
};
